import Vue from 'vue'
import Vuex from 'vuex'
import {
	getToken
} from '@/uitlis/auth'
Vue.use(Vuex)

const state = {
	isToken: false,
	ifLOGIN: true,
	isCourse: false,
	isClassRecord: false,
	new_pacpre: "",
	vadeoTimer: 0,
	gotimer: 0,
	sectionId: 0,
	courseId: 0,
	new_pacpreTxt: '',
	majorIds: "",
	phone: '手机号不存在!!!',
	enable_select_major: true,
	backUrl: window.location.origin + "/ycweb/#/index",
	baseUrls: "https://wx.yixueks.com/wxh5/#",
	liveInfo: {},
	showLive: false,
	showInvite: 0,
	isContentVideoPause:false,
	isAnalysisVideoPause:false,
	isMedicalContentVideoPause:false,
	medicalContentVideoId:-1,
	taskId:0,
  majorsList:[]
};
state.isToken = getToken() != undefined && getToken() != '' && getToken() != null

const store = new Vuex.Store({
	state
})


export default store



// WEBPACK FOOTER //
// ./store/index.js